(() => {
  const d = document, root = d.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c = d) => c.querySelector(s), $$ = (s, c = d) => [...c.querySelectorAll(s)];

  /* Hero entrance */
  requestAnimationFrame(() => requestAnimationFrame(() => {
    root.classList.add('is-ready');
  }));

  /* Rotating service word: loops continuously. The slot keeps a fixed width (widest word) so layout never shifts;
     the highlight and the trailing "that work." move with transforms/absolute boxes only. */
  const rot = $('[data-rot]');
  if (rot && !reduce) {
    const words = $$('.rot__w', rot); let i = 0, maxW = 0;
    const after = rot.parentElement.querySelector('.rot-after');
    const pad = () => parseFloat(getComputedStyle(rot).paddingLeft) * 2;
    const widthOf = w => { const h = w.hidden; w.hidden = false; const v = w.getBoundingClientRect().width; w.hidden = h; return v; };
    const measure = () => { rot.style.width = ''; maxW = Math.max(...words.map(widthOf)) + pad(); rot.style.width = maxW + 'px'; rot.classList.add('is-fixed'); };
    const setW = w => { const cw = widthOf(w) + pad(); rot.style.setProperty('--rw', cw + 'px'); if (after) after.style.transform = 'translateX(' + (cw - maxW) + 'px)'; };
    (d.fonts ? d.fonts.ready : Promise.resolve()).then(() => { measure(); setW(words[i]); });
    addEventListener('resize', () => { measure(); setW(words[i]); });
    const tick = () => {
      if (d.hidden) return setTimeout(tick, 1200);
      const cur = words[i]; i = (i + 1) % words.length; const nxt = words[i];
      cur.classList.add('is-out');
      nxt.hidden = false; nxt.classList.add('is-in');
      rot.style.setProperty('--hl', nxt.dataset.hl); rot.style.setProperty('--hl-fg', nxt.dataset.fg || 'var(--ink)'); setW(nxt);
      requestAnimationFrame(() => requestAnimationFrame(() => nxt.classList.remove('is-in')));
      setTimeout(() => { cur.hidden = true; cur.classList.remove('is-out'); }, 600);
      setTimeout(tick, 2400);
    };
    setTimeout(tick, 2400);
  }

  /* ---- Motion layer ---- */
  const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* Hero underline draws after the headline lands */
  const mark = $('[data-mark]');
  if (mark) setTimeout(() => mark.classList.add('is-drawn'), reduce ? 0 : 1050);

  /* Section headlines: words rise in (split text nodes, keep <br> and other markup) */
  $$('.h2').forEach(h => {
    let i = 0;
    const walk = n => [...n.childNodes].forEach(c => {
      if (c.nodeType === 3) {
        const f = d.createDocumentFragment();
        c.textContent.split(/(\s+)/).forEach(p => {
          if (!p) return;
          if (/^\s+$/.test(p)) { f.appendChild(d.createTextNode(' ')); return; }
          const w = d.createElement('span'); w.className = 'wd';
          const s = d.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
          w.appendChild(s); f.appendChild(w);
        });
        c.replaceWith(f);
      } else if (c.nodeType === 1 && c.tagName !== 'BR') walk(c);
    });
    walk(h);
    if (!h.closest('.rv')) h.classList.add('rv');
  });

  /* Process line: a gentle wave drawn through the real centre of every step dot */
  const steps = $('.steps'), line = steps && $('.steps__line svg', steps);
  if (line) {
    const path = $('path', line);
    const build = () => {
      const sr = steps.getBoundingClientRect();
      const pts = $$('.step__dot', steps).map(el => { const r = el.getBoundingClientRect(); return [r.left - sr.left + r.width / 2, r.top - sr.top + r.height / 2]; });
      if (pts.length < 2) return;
      const W = sr.width, H = 56, a = 22;
      line.setAttribute('viewBox', `0 0 ${W.toFixed(1)} ${H}`);
      let dd = `M${pts[0][0].toFixed(1)} ${pts[0][1].toFixed(1)}`;
      for (let k = 1; k < pts.length; k++) {
        const [x0, y0] = pts[k - 1], [x1, y1] = pts[k], dx = (x1 - x0) / 3, s = k % 2 ? -a : a;
        dd += ` C${(x0 + dx).toFixed(1)} ${(y0 + s).toFixed(1)}, ${(x1 - dx).toFixed(1)} ${(y1 - s).toFixed(1)}, ${x1.toFixed(1)} ${y1.toFixed(1)}`;
      }
      path.setAttribute('d', dd);
    };
    build(); d.fonts && d.fonts.ready.then(build);
    let rt; addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(build, 120); });
  }

  /* CTA highlight */
  const ctaBox = $('.cta__box');
  if (ctaBox) {
    if (reduce) ctaBox.classList.add('is-in');
    else { const o = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { ctaBox.classList.add('is-in'); o.disconnect(); } }), { threshold: .4 }); o.observe(ctaBox); }
  }

  /* Reveal on scroll */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
  $$('.rv').forEach(el => io.observe(el));

  /* Play illustrations when visible */
  const play = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-play'); play.unobserve(e.target); }
  }), { threshold: .35 });
  $$('[data-play]').forEach(el => play.observe(el));

  /* Stacked project cards: scale/dim the card underneath + small media parallax */
  const cards = $$('.proj');
  const stickers = $$('[data-sticker]');
  const hdr = $('.hdr');
  let lastY = scrollY, ticking = false;
  const onScroll = () => {
    ticking = false;
    const y = scrollY, vh = innerHeight;
    if (hdr) hdr.classList.toggle('is-scrolled', y > 8);
    if (hdr) hdr.classList.toggle('is-hidden', y > lastY && y > 600 && !d.body.classList.contains('menu-open'));
    lastY = y;
    if (reduce) return;
    if (innerWidth > 860) {
      cards.forEach((li, idx) => {
        const card = li.firstElementChild, next = cards[idx + 1];
        let p = 0;
        if (next) {
          const nr = next.getBoundingClientRect(), top = parseFloat(getComputedStyle(next).top);
          p = Math.min(1, Math.max(0, 1 - (nr.top - top) / (vh * .85)));
        }
        card.style.setProperty('--s', (1 - p * .06).toFixed(4));
        card.style.setProperty('--b', (1 - p * .18).toFixed(4));
        const m = card.querySelector('[data-par]');
        if (m) {
          const r = card.getBoundingClientRect();
          const q = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / vh));
          m.style.setProperty('--py', (q * 26).toFixed(1) + 'px');
        }
      });
    }
    stickers.forEach(st => st.style.setProperty('--rot', (y * .12 % 360).toFixed(1) + 'deg'));
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  addEventListener('resize', onScroll); onScroll();

  /* Testimonials controls */
  const qs = $('[data-quotes]');
  if (qs) {
    const btns = $$('[data-q]');
    const upd = () => {
      btns[0].disabled = qs.scrollLeft < 8;
      btns[1].disabled = qs.scrollLeft + qs.clientWidth > qs.scrollWidth - 8;
    };
    btns.forEach(b => b.addEventListener('click', () => {
      const w = qs.firstElementChild.getBoundingClientRect().width + 18;
      qs.scrollBy({ left: w * +b.dataset.q, behavior: reduce ? 'auto' : 'smooth' });
    }));
    qs.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true }); upd();
  }

  /* Header dropdowns: click/Enter toggles, hover opens on mouse devices, Escape and outside click close */
  const dds = $$('.nav__dd');
  if (dds.length) {
    const hoverable = matchMedia('(hover:hover) and (pointer:fine)');
    const setOpen = (li, on) => { li.classList.toggle('is-open', on); $('.nav__btn', li).setAttribute('aria-expanded', on ? 'true' : 'false'); };
    const closeAll = except => dds.forEach(li => li !== except && setOpen(li, false));
    dds.forEach(li => {
      const btn = $('.nav__btn', li); let t;
      btn.addEventListener('click', () => { if (li._hov) { li._hov = false; return setOpen(li, true); } const on = !li.classList.contains('is-open'); closeAll(li); setOpen(li, on); });
      li.addEventListener('mouseenter', () => { if (!hoverable.matches) return; clearTimeout(t); closeAll(li); if (!li.classList.contains('is-open')) li._hov = true; setOpen(li, true); });
      li.addEventListener('mouseleave', () => { if (!hoverable.matches) return; li._hov = false; t = setTimeout(() => setOpen(li, false), 160); });
      li.addEventListener('focusout', e => { if (!li.contains(e.relatedTarget)) setOpen(li, false); });
      li.addEventListener('keydown', e => { if (e.key === 'Escape' && li.classList.contains('is-open')) { setOpen(li, false); btn.focus(); } });
      $$('a', li).forEach(a => a.addEventListener('click', () => setOpen(li, false)));
    });
    d.addEventListener('click', e => { if (!e.target.closest('.nav__dd')) closeAll(); });
  }

  /* Mobile menu groups */
  $$('.drawer__btn').forEach(b => b.addEventListener('click', () => {
    const on = b.getAttribute('aria-expanded') !== 'true'; b.setAttribute('aria-expanded', on ? 'true' : 'false');
    d.getElementById(b.getAttribute('aria-controls')).hidden = !on;
  }));

  /* Mobile drawer with focus trap */
  const burger = $('.burger'), drawer = $('#drawer');
  if (burger && drawer) {
    const focusables = () => $$('a,button', drawer).filter(el => el.offsetParent !== null);
    const open = () => {
      drawer.classList.add('is-open'); d.body.classList.add('menu-open'); d.body.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded', 'true'); setTimeout(() => $('.drawer__close', drawer).focus(), 50);
    };
    const close = (ret = true) => {
      drawer.classList.remove('is-open'); d.body.classList.remove('menu-open'); d.body.style.overflow = '';
      burger.setAttribute('aria-expanded', 'false'); if (ret) burger.focus();
    };
    burger.addEventListener('click', open);
    $('.drawer__close', drawer).addEventListener('click', () => close());
    $$('a', drawer).forEach(a => a.addEventListener('click', () => close(false)));
    drawer.addEventListener('keydown', e => {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        const f = focusables(), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }


  /* Statement: words fill in as it scrolls through the viewport; listed words get a highlight */
  $$('[data-say]').forEach(el => {
    const hl = (el.dataset.hl || '').split(',').map(w => w.trim().toLowerCase()).filter(Boolean);
    const cols = ['var(--lime)', 'var(--pink)', 'var(--sky)', 'var(--lilac)'];
    const text = el.textContent.trim(); el.textContent = '';
    const words = []; let k = 0;
    const tokens = text.split(/\s+/);
    for (let t = 0; t < tokens.length; t++) {
      let matched = 0;
      for (const h of hl) { const n = h.split(/\s+/).length; const seg = tokens.slice(t, t + n).join(' ').toLowerCase().replace(/[^\w\s'-]/g, ''); if (seg === h) { matched = n; break; } }
      const span = d.createElement('span'); span.className = 'w';
      if (matched) { span.textContent = tokens.slice(t, t + matched).join(' '); span.classList.add('hl'); span.style.setProperty('--c', cols[k++ % cols.length]); t += matched - 1; }
      else span.textContent = tokens[t];
      el.appendChild(span); el.appendChild(d.createTextNode(' ')); words.push(span);
    }
    if (reduce) { words.forEach(w => w.classList.add('on')); return; }
    const upd = () => {
      const r = el.getBoundingClientRect(), vh = innerHeight;
      const p = Math.min(1, Math.max(0, (vh * .85 - r.top) / (vh * .5 + r.height * .6)));
      const n = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('on', i < n));
    };
    addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true }); upd();
  });

  /* Portfolio index: hovering or focusing a project swaps the preview */
  const wix = $('[data-wix]');
  if (wix) {
    const rows = $$('[data-wix-i]', wix), figs = $$('[data-wix-fig]');
    const show = i => { rows.forEach(r => r.classList.toggle('is-on', r.dataset.wixI === i)); figs.forEach(f => f.classList.toggle('is-on', f.dataset.wixFig === i)); };
    rows.forEach(r => { r.addEventListener('mouseenter', () => show(r.dataset.wixI)); r.addEventListener('focus', () => show(r.dataset.wixI)); });
  }


  /* Design-to-build comparison: plays once in view, then the visitor can drag it */
  $$('[data-db]').forEach(el => {
    const st = $('.db__stage', el), r = $('.db__range', el);
    if (!st || !r) return;
    let touched = false;
    const set = v => { st.style.setProperty('--x', v + '%'); r.value = Math.round(v); };
    r.addEventListener('input', () => { touched = true; set(+r.value); });
    const rest = +(el.dataset.rest || 50);
    if (reduce || (window.Shopify && Shopify.designMode)) { el.classList.add('is-on'); set(rest); return; }
    set(100);
    const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const tween = (from, to, ms) => new Promise(res => {
      const t0 = performance.now();
      const step = now => { if (touched) return res(); const p = Math.min(1, (now - t0) / ms); set(from + (to - from) * ease(p)); p < 1 ? requestAnimationFrame(step) : res(); };
      requestAnimationFrame(step);
    });
    const io = new IntersectionObserver(es => {
      if (!es[0].isIntersecting) return;
      io.disconnect(); el.classList.add('is-on');
      setTimeout(async () => { await tween(100, 4, 1800); await tween(4, rest, 1000); }, 1300);
    }, { threshold: .35 });
    io.observe(el);
  });


  /* Email gallery: columns drift continuously (paused only while off-screen, to save battery) */
  $$('.ew [data-ew]').forEach(stage => {
    if (!('IntersectionObserver' in window)) return stage.classList.add('is-visible');
    new IntersectionObserver(es => es.forEach(e => stage.classList.toggle('is-visible', e.isIntersecting)), { rootMargin: '200px' }).observe(stage);
  });

  /* Campaign calendar: highlights each campaign in turn and shows its email in the phone */
  const watch = (el, fn) => {
    if (!('IntersectionObserver' in window)) return fn(true);
    new IntersectionObserver(es => es.forEach(e => fn(e.isIntersecting)), { threshold: .2 }).observe(el);
  };
  $$('[data-cp]').forEach(board => {
    const chips = $$('[data-cp-chip]', board), mails = $$('[data-cp-mail]', board), labels = $$('[data-cp-label]', board);
    if (!chips.length) return;
    const DUR = 6500; let cur = 0, timer, visible = false, started = false;
    board.style.setProperty('--cp-dur', DUR + 'ms');
    const set = i => {
      cur = i;
      chips.forEach((c, k) => { c.classList.toggle('is-on', k === i); c.setAttribute('aria-pressed', k === i); });
      mails.forEach((m, k) => m.classList.toggle('is-on', k === i));
      labels.forEach((l, k) => l.classList.toggle('is-on', k === i));
      clearTimeout(timer);
      if (!reduce) timer = setTimeout(next, DUR);
    };
    const next = () => { if (!visible) { timer = setTimeout(next, 600); return; } set((cur + 1) % chips.length); };
    chips.forEach((c, k) => c.addEventListener('click', () => set(k)));
    watch(board, v => { visible = v; board.classList.toggle('is-paused', !v); if (v && !started) { started = true; set(0); } });
  });

  /* Flow builder: tabs switch flows; a highlight walks through each flow, then moves to the next one */
  $$('[data-fb]').forEach(canvas => {
    const sec = canvas.closest('.fb'), tabs = $$('[data-fb-tab]', sec), panels = $$('[data-fb-panel]', canvas);
    if (!panels.length) return;
    const STEP = 950, LEAD = 600, HOLD = 1800;
    let cur = 0, timer, visible = false, started = false, seq = [], at = 0;
    panels.forEach(p => $$('[data-fb-node], .fb__yn', p).forEach((n, i) => n.style.setProperty('--i', i)));
    const clear = () => $$('.is-cur, .is-done, .is-skip', canvas).forEach(n => n.classList.remove('is-cur', 'is-done', 'is-skip'));
    const tick = () => {
      if (!visible) { timer = setTimeout(tick, 500); return; }
      if (at < seq.length) {
        seq.forEach((n, k) => { n.classList.toggle('is-cur', k === at); n.classList.toggle('is-done', k < at); });
        if (seq[at].closest('.fb__branches')) $$('.fb__br--yes [data-fb-node]', panels[cur]).forEach(n => n.classList.add('is-skip'));
        at++; timer = setTimeout(tick, STEP);
      } else timer = setTimeout(() => show((cur + 1) % panels.length), HOLD);
    };
    const show = (i, focus) => {
      cur = i; clearTimeout(timer); clear();
      tabs.forEach((t, k) => { const on = k === i; t.classList.remove('is-on'); t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      void sec.offsetWidth;
      tabs[i].classList.add('is-on');
      panels.forEach((p, k) => p.classList.toggle('is-on', k === i));
      if (focus) tabs[i].focus();
      if (tabs[i].scrollIntoView && tabs[0].parentElement.scrollWidth > tabs[0].parentElement.clientWidth) tabs[0].parentElement.scrollTo({ left: tabs[i].offsetLeft - tabs[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      if (reduce) return;
      seq = $$('.fb__flow > [data-fb-node]', panels[i]).concat($$('.fb__br--no [data-fb-node]', panels[i])); at = 0;
      sec.style.setProperty('--fb-dur', (LEAD + seq.length * STEP + HOLD) + 'ms');
      timer = setTimeout(tick, LEAD);
    };
    tabs.forEach((t, k) => {
      t.addEventListener('click', () => show(k));
      t.addEventListener('keydown', e => {
        const dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (dir) { e.preventDefault(); show((k + dir + tabs.length) % tabs.length, true); }
        else if (e.key === 'Home') { e.preventDefault(); show(0, true); }
        else if (e.key === 'End') { e.preventDefault(); show(tabs.length - 1, true); }
      });
    });
    watch(sec, v => { visible = v; sec.classList.toggle('is-paused', !v); if (v && !started) { started = true; show(0); } });
  });

  /* Ways to work together: monthly hours fill up; single requests move through their steps */
  $$('[data-plh]').forEach(el => {
    const items = $$('li', el), num = $('[data-plh-n]', el), total = +el.dataset.total || 1;
    if (reduce || !items.length) return;
    let i = 0, used = 0, visible = false, timer;
    const render = () => { num.textContent = used; el.style.setProperty('--off', 1 - used / total); };
    const reset = () => { i = 0; used = 0; items.forEach(li => li.classList.remove('is-done')); render(); };
    const tick = () => {
      if (!visible) { timer = setTimeout(tick, 600); return; }
      if (i < items.length) { items[i].classList.add('is-done'); used += +items[i].dataset.h || 0; i++; render(); timer = setTimeout(tick, 1100); }
      else timer = setTimeout(() => { reset(); timer = setTimeout(tick, 900); }, 2600);
    };
    el.classList.add('is-anim'); reset();
    watch(el, v => { visible = v; if (v && !timer) timer = setTimeout(tick, 500); });
  });
  $$('[data-plj]').forEach(el => {
    const reqs = $$('.plj__req', el), steps = $$('.plj__steps li', el), bar = $('.plj__steps', el);
    const last = steps.length - 1;
    const show = (r, st) => {
      reqs.forEach((q, k) => q.classList.toggle('is-on', k === r));
      steps.forEach((li, k) => { li.classList.toggle('is-done', k < st || (k === st && st === last)); li.classList.toggle('is-now', k === st && st !== last); });
      bar.style.setProperty('--step', st * 3 / Math.max(last, 1));
    };
    if (reduce || !reqs.length) { show(0, last); return; }
    let r = 0, st = 0, visible = false, timer;
    const tick = () => {
      if (!visible) { timer = setTimeout(tick, 600); return; }
      if (st < last) { st++; show(r, st); timer = setTimeout(tick, st === last ? 2000 : 1200); }
      else { r = (r + 1) % reqs.length; st = 0; show(r, st); timer = setTimeout(tick, 1200); }
    };
    show(0, 0);
    watch(el, v => { visible = v; if (v && !timer) timer = setTimeout(tick, 900); });
  });

  /* Email & SMS hero: new messages keep arriving on the lock screen */
  $$('[data-ems]').forEach(el => {
    const ns = $$('[data-ems-n]', el), n = ns.length;
    if (reduce || n < 4) return;
    let off = 0, visible = false;
    const place = () => ns.forEach((li, k) => {
      const slot = (k - off + n) % n; // 0 = newest
      const cls = slot < 3 ? 's' + slot : slot === 3 ? 'out' : 'in';
      li.classList.remove('s0', 's1', 's2', 'out', 'in'); li.classList.add(cls);
    });
    const order = () => { off = (off - 1 + n) % n; };
    setInterval(() => { if (!visible) return; order(); place(); }, 2600);
    watch(el, v => { visible = v; });
  });

  /* Inquiry source: remembers the page a visitor came from and any ?ref= link tag,
     and adds them to the Work With Us form as a hidden "Came from" field */
  (() => {
    let ls; try { ls = window.localStorage; ls.setItem('sd_t', '1'); ls.removeItem('sd_t'); } catch (e) { return; }
    const read = k => { try { return JSON.parse(ls.getItem(k) || 'null'); } catch (e) { return null; } };
    const now = Date.now(), DAY = 864e5, path = location.pathname;
    const title = (d.title || '').split(' | ')[0].trim();
    const qs = new URLSearchParams(location.search);
    const tag = (qs.get('ref') || qs.get('utm_source') || '').slice(0, 60);
    if (tag) ls.setItem('sd_ref', JSON.stringify({ v: tag, t: now }));
    let first = read('sd_first');
    if (!first || now - first.t > 30 * DAY) { first = { p: path, t: now }; ls.setItem('sd_first', JSON.stringify(first)); }
    const last = read('sd_last');
    if (last && last.p !== path) ls.setItem('sd_before', JSON.stringify(last));
    ls.setItem('sd_last', JSON.stringify({ p: path, n: title, t: now }));
    const field = d.querySelector('[data-came-from]');
    if (!field) return;
    const before = read('sd_before'), ref = read('sd_ref'), parts = [];
    if (before && before.p !== path && now - before.t < DAY) parts.push('Previous page: ' + (before.n || before.p));
    if (ref && now - ref.t < 30 * DAY) parts.push('Link tag: ' + ref.v);
    if (first && first.p !== path) parts.push('First page: ' + first.p);
    field.value = parts.join(' | ') || 'Direct to this page';
  })();

  /* Work With Us: the project brief card fills in as the visitor types */
  $$('[data-brief]').forEach(card => {
    const f = d.getElementById(card.dataset.brief);
    if (!f || f.querySelector('.bq__ok')) { card.hidden = true; return; }
    const val = n => ((f.elements[n] && f.elements[n].value) || '').trim();
    const set = (k, v) => {
      const el = card.querySelector('[data-b="' + k + '"]');
      if (!el) return;
      const next = v || el.dataset.ph, was = el.textContent;
      if (next === was) return;
      el.textContent = next;
      el.classList.toggle('is-ph', !v);
      if (!reduce && v && !was.startsWith(v.slice(0, -1))) { el.classList.remove('is-new'); void el.offsetWidth; el.classList.add('is-new'); }
    };
    const needs = card.querySelector('[data-b-needs]'), bar = card.querySelector('[data-b-bar]'), count = card.querySelector('[data-b-count]'), status = card.querySelector('[data-b-status]');
    let picked = '';
    const update = () => {
      set('name', val('contact[name]'));
      set('email', val('contact[email]'));
      set('company', val('contact[Company]'));
      set('site', val('contact[Website]').replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/$/, ''));
      set('body', val('contact[body]'));
      const t = f.querySelector('input[name="contact[Timing]"]:checked');
      set('timing', t ? t.value : '');
      const wh = f.querySelector('input[name="contact[Describes you]"]:checked');
      set('who', wh ? wh.value.replace(/^An? /, '').replace(/^./, c => c.toUpperCase()) : '');
      const bu = f.querySelector('input[name="contact[Budget]"]:checked');
      set('budget', bu ? bu.value : '');
      const svcs = $$('input[data-svc]:checked', f).map(i => i.dataset.svc), key = svcs.join('|');
      if (needs && key !== picked) {
        picked = key;
        needs.textContent = '';
        if (!svcs.length) { const p = d.createElement('span'); p.className = 'is-ph'; p.textContent = 'Choose a service'; needs.append(p); }
        svcs.forEach(n => { const tag = d.createElement('span'); tag.className = 'bq__tag'; tag.textContent = n; needs.append(tag); });
      }
      const email = f.elements['contact[email]'];
      const done = [val('contact[name]'), email && email.value.trim() && email.validity.valid, val('contact[body]')].filter(Boolean).length;
      if (bar) bar.style.width = (done / 3 * 100) + '%';
      if (count) count.textContent = done === 3 ? 'Ready to send' : done + ' of 3 required';
      if (status) status.textContent = done === 3 ? 'Ready' : 'Draft';
      card.classList.toggle('is-ready', done === 3);
    };
    f.addEventListener('input', update);
    f.addEventListener('change', update);
    update();
  });

  /* Theme editor: sections re-rendered by Shopify are shown straight away */
  d.addEventListener('shopify:section:load', e => {
    $$('.rv', e.target).forEach(el => el.classList.add('is-in'));
    $$('[data-play]', e.target).forEach(el => el.classList.add('is-play'));
  });
})();
